import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

//COMPONENTS
import ButtonCustom from "../../../../../../../Components/ButtonCustom";
import { Inline } from "../../../../../../../Components/CustomUi/inline";
import { Switcher } from "../../../../../../../Components/CustomUi/Switcher";
import Carregando from '../../../../../../../Components/CustomUi/loading';

interface Props {
    breakAvoid: boolean;
    setBreakAvoid: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_print_settings: React.Dispatch<React.SetStateAction<boolean>>;
    onPrint?: () => void;
    loading: boolean
}

export const Imprimir: React.FC<Props> = ({
    breakAvoid,
    setBreakAvoid,
    setOpen_print_settings,
    onPrint,
    loading
}) => {

    //STATES
    const [fake_loading, setFake_loading] = useState<boolean>(true);
    const initialLoadingRef = useRef(loading);

    useEffect(() => {
        if (!loading) {
            const time = setTimeout(() => {
                setFake_loading(false);
            }, 3000);
            return () => {
                clearTimeout(time);
            }
        } else {
            setFake_loading(true);
        }
    }, [loading]);

    return (
        <Inline style={{ flexDirection: 'column' }} >
            {(fake_loading || loading)
                ? <Carregando justifyContent='center' animation legenda='Preparando impressão...' />
                : <>
                    <Switcher
                        isChecked={breakAvoid}
                        trigger={setBreakAvoid}
                        label='Quebrar página antes do card'
                    />
                    <ButtonCustom
                        onClick={() => {
                            setOpen_print_settings(false);
                            onPrint?.();
                        }}
                        icon={<FontAwesomeIcon icon={faPrint} />}
                        type="primary"
                        style={{ alignSelf: 'flex-start', marginTop: 5 }}
                    >
                        Imprimir
                    </ButtonCustom>
                </>
            }

        </Inline>
    );
};
